import { render, staticRenderFns } from "./BadgeListChemical.vue?vue&type=template&id=9d8cd220&scoped=true&"
import script from "./BadgeListChemical.vue?vue&type=script&lang=js&"
export * from "./BadgeListChemical.vue?vue&type=script&lang=js&"
import style0 from "./BadgeListChemical.vue?vue&type=style&index=0&id=9d8cd220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8cd220",
  null
  
)

export default component.exports